import React, {
  createContext,
  Dispatch,
  useContext,
  useMemo,
  useState
} from 'react';

type DrawerOnCloseContextType = {
  drawerOnClose?: () => void;
  setDrawerOnClose: Dispatch<React.SetStateAction<(() => void) | undefined>>;
};

export const DrawerOnCloseContext = createContext<
  DrawerOnCloseContextType | undefined
>(undefined);

export const useDrawerOnCloseContext = (): DrawerOnCloseContextType => {
  const value = useContext(DrawerOnCloseContext);
  if (!value) {
    throw Error('should be called in DrawerOnCloseContextProvider scope');
  }
  return value;
};

const DrawerOnCloseContextProvider: React.FC = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const [drawerOnClose, setDrawerOnClose] = useState<(() => void) | undefined>(
    undefined
  );

  const value = useMemo(
    () => ({
      drawerOnClose: drawerOnClose,
      setDrawerOnClose: setDrawerOnClose
    }),
    [drawerOnClose, setDrawerOnClose]
  );

  return (
    <DrawerOnCloseContext.Provider value={value}>
      {children}
    </DrawerOnCloseContext.Provider>
  );
};

export default DrawerOnCloseContextProvider;
